import { useEffect, useState } from "react";
import "./VoxWelcomeLoader.css";

export default function VoxWelcomeLoader({ loading = true, onFinish }) {
  const [progress, setProgress] = useState(0);
  const [phase, setPhase] = useState("enter"); // enter | exit

  useEffect(() => {
    if (!loading) {
      setPhase("exit");
      const t = setTimeout(() => onFinish?.(), 500);
      return () => clearTimeout(t);
    }
  }, [loading, onFinish]);

  useEffect(() => {
    if (!loading) return;
    const interval = setInterval(() => {
      setProgress((p) => {
        if (p >= 92) return p;
        const inc = Math.random() * 8 + 2;
        return Math.min(p + inc, 92);
      });
    }, 180);
    return () => clearInterval(interval);
  }, [loading]);

  useEffect(() => {
    if (!loading) {
      setProgress(100);
    }
  }, [loading]);

  if (phase === "exit" && progress === 100) {
    // still renders during exit animation, handled by CSS
  }

  return (
    <div className={`bg-black vox-welcome ${phase === "exit" ? "is-exiting" : ""}`} aria-live="polite" >
      <div className="vox-welcome-bg">
        <div className="vox-welcome-glow vox-welcome-glow-1" />
        <div className="vox-welcome-glow vox-welcome-glow-2" />
      </div>

      <div className="vox-welcome-card">
        <div className="vox-welcome-top">
          <span className="vox-welcome-kicker">
            <span className="vox-welcome-dot" /> ULTRAVOX • EN VIVO
          </span>
          <span className="vox-welcome-time">{new Date().toLocaleDateString("es-AR", { weekday: "long", day: "numeric", month: "long" })}</span>
        </div>

        <div className="vox-welcome-brand">
          <div className="vox-welcome-logo">
            <span className="vox-welcome-logo-mark">VOX</span>
            <span className="vox-welcome-logo-sub">NEUQUÉN</span>
          </div>
          <div className="vox-welcome-wording">
            <h1 className="vox-welcome-title">
              Bienvenido a <br />
              <span>Ultravox</span>
            </h1>
            <p className="vox-welcome-subtitle">Cargando lo más importante de Neuquén, en tiempo real.</p>
          </div>
        </div>

        <div className="vox-welcome-progress-wrap">
          <div className="vox-welcome-progress-track">
            <div className="vox-welcome-progress-bar" style={{ width: `${progress}%` }} />
          </div>
          <div className="vox-welcome-progress-meta">
            <span className="vox-welcome-progress-label">Sincronizando redacción</span>
            <span className="vox-welcome-progress-pct">{Math.round(progress)}%</span>
          </div>
        </div>

        <div className="vox-welcome-foot">
          <div className="vox-welcome-foot-left">
            <span>NEUQUÉN CAPITAL</span>
            <span>•</span>
            <span>PATAGONIA ARGENTINA</span>
          </div>
          <div className="vox-welcome-foot-right">
            <span className="vox-welcome-foot-live">
              <i /> CARGANDO
            </span>
          </div>
        </div>
      </div>

      <div className="vox-welcome-bottom">
        <span>Periodismo local, sin ruido</span>
        <span>•</span>
        <span>Edición premium</span>
      </div>
    </div>
  );
}
